$(document).ready(function () {
  var original_html = $(".header").html();
  var x;
  $(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = $(window).width();
    var logo = $(".header-logo").html();
    if (newWindowWidth > 767) {
      $(".header").html(original_html);
      x = 2;
    }
    if (newWindowWidth < 768 && (x === 2 || x === undefined)) {
      $(".header").append('<div class="mobile-menu-wrap"></div>');
      $(".mobile-menu-wrap").append('<div class="mobile-menu-logo"></div>');
      $(".mobile-menu-wrap").append('<div class="offer-img"></div>');
      $(".mobile-menu-wrap").append('<div class="main-mobile-menu"></div>');
      $(".mobile-menu-wrap").append('<div class="mobile-user"></div>');
      $(".img-menu").prependTo(".offer-img");
      $(".img-menu").removeClass("inner-menu-col");
      $(".main-menu").prependTo(".main-mobile-menu");
      $(".rm-menu-item").appendTo(".main-menu");
      $(".user-icon").appendTo(".mobile-user");
      $(".close-btn").appendTo(".mobile-menu-logo");
      $(logo).appendTo(".mobile-menu-logo");
      $(".search-icon").appendTo(".mobile-menu-logo");

      $(".main-menu li .inner-meun").parent("li").addClass("main-submenu");
      $(".inner-menu-col .inner-menu-title")
        .parent(".inner-menu-col")
        .addClass("submenu");
      $(".main-submenu > a").click(function () {
        $(this).parent(".main-submenu").children(".inner-meun").toggle(100);
      });
      $(".submenu .inner-menu-title").click(function () {
        $(this).parent(".submenu").children("ul").toggle(100);
      });
      $(".search-icon .fa-search").click(function () {
        $(".search-icon .mobilenav-search-new").show();
        $(".mobilenav-search-new").addClass("extrasearch");
      });
      $(".close-search").click(function () {
        $(".mobilenav-search-new").addClass("showsearch");
        $(".mobilenav-search-new").removeClass("extrasearch");
      });
      $(".main-submenu>a").click(function () {
        event.preventDefault();
      });
      $(".main-submenu .inner-menu-col.submenu .inner-menu-title>a").click(
        function () {
          event.preventDefault();
        }
      );
      // $(".main-submenu .submenu ul li>a").click(function () {
      //   event.preventDefault();
      // });
      $(".not-tabbing-mob>li").addClass("inner-menu-title");
      $(".inner-menu-col.submenu:last-child").removeClass("submenu");
      x = 1;
      $(".mobile-menu-wrap").css("display", "none");
    } else {
      // $(".header").html(original_html);
    }

    $(".hamburger-icon").click(function () {
      $(".mobile-menu-wrap").css("left", "0");
      $(".mobile-menu-wrap").css("display", "block");
      $(".mobile-menu-wrap").css("width", "100%");
    });
    $(".close-btn").click(function () {
      $(".mobile-menu-wrap").css("left", "-100vw");
      $(".mobile-menu-wrap").css("width", "auto");
    });
  }
});
